<template>
    <transition name="el-fade-in" mode="out-in">
        <div class="el-message-box__wrapper" style="z-index: 2250;">
            <div class="el-message-box">
                <div class="el-message-box__header">
                    <div class="el-message-box__title">可数名册的复数形式</div>
                    <div class="btn1" @click="$router.go(-1)">
                        <img src="../../../../assets/img/grammarTest/close.png" alt="">
                    </div>
                </div>
                <div class="el-message-box__content">
                    <div class="content-box">
                        <div class="analysis-box">
                            <img src="../../../../assets/img/grammarTest/analysis.png" alt="">
                            <img src="../../../../assets/img/grammarTest/analysis.png" alt="">
                            <img src="../../../../assets/img/grammarTest/analysis.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "analysis",
        data() {
            return {};
        },
        methods: {
            close() {
                this.isHint = false;
                this.isDemo = true
            },
            closePop() {
                this.isHint = true;
                this.isDemo = false
            },
        },
        created() {

        },
    }
</script>

<style scoped lang='less'>
    .el-message-box {
        width: 1000px;
        /*min-height: 560px;*/
    }

    .el-message-box__wrapper {
        background: rgba(0, 0, 0, 0.3);

        .el-message-box__header {
            padding: 25px;
            border-bottom: 1px solid #dcdcdc;
        }

        .el-message-box__content {
        }

        .el-message-box__btns {
            font-size: 14px;
            position: absolute;
            right: 0;
            bottom: 0;
        }


        .left-title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            > div:nth-of-type(1) {
                display: flex;
                align-items: center;

                p {
                    font-size: 18px;
                }

                img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }
            }


        }

        .content-box {
            min-height: 450px;
            max-height: 100px;
            overflow-y: scroll;
            transition: all .5s;

            .analysis-box {
                img {
                    width: 100%;
                }
            }

        }
    }


</style>